"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
document.querySelector(".contact-us__form").addEventListener("submit", function(event) {
    event.preventDefault();
    document.querySelector(".contact-us__form").reset();
});

//# sourceMappingURL=index.ffd75416.js.map
